import type { BillingCycle } from '@hotjar/account';
import { BILLING_CYCLE } from '@hotjar/checkout';
import type { BillingPeriod } from '@hotjar/subscription-management';

export function mapV2BillingCycleToV3BillingPeriod(
  billingCycle: BILLING_CYCLE | BillingCycle,
): BillingPeriod {
  switch (billingCycle) {
    case BILLING_CYCLE.monthly || 'monthly':
      return 'MONTHLY';
    case BILLING_CYCLE.yearly || 'yearly_recurring':
      return 'ANNUALLY';
    default:
      throw new Error(`Failed to map v2 billing cycle ${billingCycle} to v3 billing period.`);
  }
}

export function mapV3BillingPeriodToV2BillingCycle(billingPeriod: BillingPeriod): BILLING_CYCLE {
  switch (billingPeriod) {
    case 'MONTHLY':
      return BILLING_CYCLE.monthly;
    case 'ANNUALLY':
      return BILLING_CYCLE.yearly;
    default:
      throw new Error(`Failed to map v3 billing period ${billingPeriod} to v2 billing cycle.`);
  }
}
